<!--
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-03 17:35:59
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-16 14:56:13
 * @FilePath: /h5/src/divs/Spark/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="content">
		<Header></Header>
		<div class="result-wrap">
			<div class="wrap-main" id="resultWrap">
				<div class="result">
					<van-image class="avatarUrl" fit="contain" :src="userInfo.aiAvatarUrl" />
					<div class="result-info info-box default-info">
						<span><b>您好！</b><br/>
							<b>我是您的智能秘书小田~</b><br/>
							我可是个“万事通”，您有什么事儿都可以问我哦！要是我都不知道，您还可以找我大哥大田！<br/>
							他的电话是：<a href="tel:4008360128" style="color: #7FBE26;"><b>4008-360-128</b></a>
						</span>
					</div>
				</div>
				<div class="result">
					<div class="avatarUrl" style="background-color: transparent !important;"></div>
					<div class="result-info info-box default-info">
						<span>
							您可以问我各种问题，如：<br/>
							<b><i v-for="(item,index) in defaultQuestion" :key="index" @click="handleSpark(item,2)">·{{item}}<br/></i>
							</b>
							总之，我是“万事通”，随您怎么问
						</span>
					</div>
				</div>
				<!-- 呈现历史问答-结果数组格式 -->
				<div v-for="(item,index) in sparkResultList" :key="index">
					<div class="question" v-if="item.me">
						<div class="question-info info-box">
							<span v-html="item.me"></span>
						</div>
						<van-image class="avatarUrl" fit="contain" :src="userInfo.avatarUrl" />
					</div>
					<div class="result" v-if="item.ai">
						<van-image class="avatarUrl" fit="contain" :src="userInfo.aiAvatarUrl" />
						<div class="result-info info-box">
							<span v-if="item.status!=3 && index==sparkResultList.length-1 && sparkResult.isWrite" v-html="writerText"></span>
							<span v-else v-html="item.ai"></span>
							<div class="btn-group" v-if="(index!=sparkResultList.length-1 || (index==sparkResultList.length-1 && !sparkResult.isWrite)) && (item.status==2 || item.status==5)">
								<!-- 回答完毕 -->
								<template v-if="item.status==2">
									<!-- <div class="btn" v-if="item.type==1 && index==sparkResult.index" @click="aiContentPlay(item.ai)">
										<van-icon v-if="!audioIsPlay" name="play-circle-o" />
										<van-icon v-else name="pause-circle-o" />
									</div> -->
									<div class="btn" @click="copyText(item.ai)">
										<img src="@/assets/images/spark/copy_icon.png" />
									</div>
									<div class="btn" @click="handleLike(item,index)">
										<img v-if="item.isLike==0" src="@/assets/images/spark/zan_icon.png" />
										<img v-if="item.isLike==1" src="@/assets/images/spark/zan_on_icon.png" />
									</div>
									<div class="btn" @click="handleStep(item,index)">
										<img v-if="item.isStep==0" src="@/assets/images/spark/cai_icon.png" />
										<img v-if="item.isStep==1" src="@/assets/images/spark/cai_on_icon.png" />
									</div>
									<div class="btn" @click="againSpark(item,index)" v-if="index==sparkResult.index">
										<img src="@/assets/images/spark/again_icon.png" />
									</div>
								</template>
								<!-- 手动停止回答 -->
								<template v-if="item.status==5">
									<div class="btn">
										<span style="color: #666;">已停止回答</span>
									</div>
									<div class="btn" @click="againSpark(item,index)" v-if="index==sparkResult.index">
										<img src="@/assets/images/spark/again_icon.png" />
										<!-- <span>重新回答</span> -->
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<van-loading v-if="isLoading" type="spinner" color="#7FBE26" size="30px" style="text-align: center;margin-top: 10px;" />
			</div>
		</div>
		
		<div class="foot-box">
			<!-- <span ref="startPlay" @click="playNextAudio()">测试音频播放</span> -->
			<!-- 回答中 -->
			<template v-if="sparkResult.status==1 || sparkResult.isWrite">
				<div class="btn-stop">
					<span @click="stopSpark()">
						<img class="icon" src="@/assets/images/spark/stop_icon.png" />
						停止回答
					</span>
				</div>
			</template>
			<div class="tool-bar" v-if="sparkResultList.length>0 && sparkResult.status!=1 && !sparkResult.isWrite">
				<div class="btn btn-green" @click="clearSession(true)">
						<img class="icon" src="@/assets/images/spark/add_icon.png" />
						<span>创建新对话</span>
					</div>
					<div v-if="sparkResultList.length>0" class="btn" @click="historyTopic()">
						<img class="icon" src="@/assets/images/spark/historylist_icon.png" />
						<span>历史记录</span>
					</div>
				<div class="btn" @click="clearSession()">
						<img class="icon" src="@/assets/images/spark/clear_icon.png" />
						<span>清除会话</span>
					</div>
			</div>
			<div class="editor-wrap">
				<!-- <div class="editor"> -->
					<van-field v-model="text" placeholder="您有什么事儿尽管问~" :border="false" />
					<div v-if="text" class="icon btn-send" @click="handleSpark(text,2)">
						<img fit="contain" src="@/assets/images/spark/send_icon.png" />
					</div>
					<div v-else class="icon btn-sound" @click="inputType='sound'">
						<img src="@/assets/images/spark/audio_icon.png"/>
					</div>
			</div>
		</div>
		<Sound v-show="inputType=='sound'" ref="sound" @soundEnd="soundEnd" @methodChange="methodChange"></Sound>
		<NoCountBar v-if="!user"></NoCountBar>
		<div class="shengming">声明：农机万事通应用了讯飞星火认知大模型，内容仅供您参考。</div>
		<van-dialog
			class="dialog-keyword"
			v-model="keywordPop.show"
			:show-confirm-button="false"
			:show-cancel-button="false"
			:close-on-click-overlay="true"
		>
			<div class="list">
				<a class="btn" target="_blank" :href="item.h5Url || item.h5_url" v-for="(item,index) in keywordPop.list" :key="index">{{ item.keywordName || item.name }}</a>
			</div>
		</van-dialog>
		<InfoFeedback v-if="infoFeedbackShow" :infoFeedback="infoFeedback" @close="feedbackClose"></InfoFeedback>
	</div>
</template>

<script>

	import Superhuman from "./Superhuman";
	import TTSRecorder from "./TTSRecorder";
	import Sound from "./components/Sound";
	import Header from "@/components/Header";
	import NoCountBar from "./components/NoCountBar";
	import InfoFeedback from "./components/InfoFeedback"
	export default {
		components: { 
			Sound,
			Header,NoCountBar,InfoFeedback },
		data(){
			return {
				bigModel : new TTSRecorder(),
				superhuman: new Superhuman(),
				userInfo: {
					avatarUrl: 'https://himg.bdimg.com/sys/portrait/item/public.1.d56bda99.tcA8KIYQIZAq6HgjCUChOQ?tt=1707202735633',
					nickName: '我',
					aiAvatarUrl: require('@/assets/images/spark/avatar-ai.png')
				},
				text: '',
				// 正在进行中的单条问答
				sparkResult: {
					me: '',
					ai: '',
					ai_format:"",//带换行标签的ai内容
					index: -1,//此条数据对应的sparkResultList中的下标
					status: '', //0代表首次结果；1代表中间结果；2代表最后一个结果
					isWrite: false,
				},
				sparkResultList: [], // 历史会话{me:"问题",ai:"ai答复",status:"状态"}
				// sparkNum: 0, // 会话次数
				topicId:"",//话题id
				inputType:"sound",//问题录入方式 "keyboard"-键盘录入 "sound"-语音录入
				isLoading: false,
				// questionCount:0,//当前用户提问问题次数
				defaultQuestion:[
					"1204轮式拖拉机都有哪些牌子？",
					"高速插秧机价格多少钱？",
					"柴油机怎么维修？",
					"农机补贴怎么办理？",
					"农机碰了电线杆怎么办？"
				],
				// user: null,//当前登录用户信息
				code:"",//微信登录操作带过来的
				keywordPop: { // 二级关键词弹框信息
					show:false,
					list:[],
				},
				infoFeedbackShow:false,
				infoFeedback:{
					type: 1,// 赞:1 / 踩:2
					id: "",
					answerId: ""
				},
				currentTextIndex: 0,
				typeInterval: null,
				audioList:[
    // {
    //     "audio": "//NoxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//NoxAAodAYA0nmXXQRJH0dBPz7Qya7/cNkeRIcKJiJDrd/H995fvJmNX7pEgPN/wHjx5Ev9+ED9IIe0yiHYhG8mTJ7HwxDxdZba+/+9MTghl/98JnBD2TqGQftBgIhybY7Rlxh6cf+/9aIQh48OsggYg3737/e/d+M/z99j+ydlpmZtoOUg93GU99s+ny9/LjhLIgBZKMiepV0+vjfcMioZN7DnoHGVBpJx6BzEdQ8IgjD2Ij7B0YloUHAIn6GdoLKNYf8qOI1FS2fLXCcOCtQZj4E7rJ0f//NoxCkw7BYACmJfXOPL1sD5zFGyYQcqwhaDaETvDJ1eRoWeLpE6A8vFBTCvOYd2cGUIgm1KJVFmdR68LmQELBFyezqN7smaKnqvt6i8fukS0jk5Nqyw49Re1Neo5nVYMVcKaXbQstotxZZVPsp4y1Ft8tpqbxiZ1Au5DF9J/vM1vGvvVs/Wz5B5SUu6j0vf5+94tuLulZKR4Uat6xtWvXD6T2vrxZoKBKh5dpuS01RRQGTTOGZY884mU5RgLQ6TAOCuaXY6BSQnUCKTmwmmTJF3punJ4Gk5//NoxDArnA4ePjGXXTNgDkfSr2eaQrlmjDLxEsLe6SLwbV4YrtiL7HOklaCakTphZ4EkONG2YlB0acVdogdjbt89RhNPCZ/cimaSeLjjojRNy4aC3WQWOw4JHFFUmbaVp9i9XzQZAltvue//Y2sxC76Z/ecnjrPLvuk0kcuYoiaHWm1D0w9nShrDUXUOJtxy2az6u5CAZycUnhMtMUtKoFxLF4QMclrJTJN9YhNoUluGgrqbkbGMgNpHWIy8HOOocYbCYsol5raOGjgZJGTj31RJ2uSZeGnd//NoxEwpdBIqXjGXXFWtnq8zTC5uzzk86POGF+D7M+iiKeJoonZLCeTPbRz5KDulORK9SqSX+28RKHk2E88JTipVVv3VW90Sx8ufOQIXfNv7bfMfbz7KXuD+x9sWuDndHD68PXPH4Q==",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "0",
    //     "sample_rate": 16000,
    //     "seq": 1,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "ypUhEmh6IR02dC4vrGh+dLrLJFKTq88tAoOjyrgvP6Qn0l1Zt5iHmFEUtI8yOiTq9hkXD2JSPHYmxtfM0ai4ewKMsaM3RoOoNnJc1aplC30c3NwUMj2LNGZX7WuYNmSK3tj/0rIoZntnSuZ67o8V8FX/82jEcTc8Ffw1THgArZCm6sesCt6nYOxNtk+xt0Bmc8w8PswI0vj9gjuUfGpOxw9yztu2q+6MOaYxlwgP75ealevHczjJHvS+cwrbgWy1Z/vBYyjB1Q55u9+p4ln8kL1zEj1clpqTqngePFg0s5O7uLtSzPYrPZYsKEQaLJgSSRbLan3KKLJwbBFtc+JYnrAcgJAz11A3eGKxAPZe7gZhAYAAMAAGnX1dhOaAAJwN7QGFp3+zYgiDeMTuFwIG/YB51U209mXYDdQDs4MoA2gAk4B0xCSuu9n/82jEXzJ0FkZdjZgA1/XhYoMuAAQDMAQAEmCzgXUCc/Rq+re2u0pDgDI4WFhjMG8AzBEAbnjvLhW9t2f2Wv/13FmClA+cXGVyVELjJiCA4ECeFaC4A9f1v//+t//8jhmA+cUumKDFbjjLo55Ploi5XIoXDQc8n05olwl6mKiIeHbd2L1WLNZp7IzRwgyGPNfvTzXZyolJowu0BPy/KdLX1M4aYhDjMmGKBISbchfeI2ZfRPwXFCIqDNVDxUfZe+siltLUkDtKdtwVhj6k0jn+lSga1FIuR9v/82jEYET0Fucfj8ECrXZZGXjKoS97sPs6DrzdeNwBAk5x/5e1y7jqXp1vgX4YetBCNmj/rrbhCYDjVmMW7HYxOQxu7nu9jGLMbhvvbHX7nsHfl+rkollBY/lbUB55Zfu7X7rPtE5b/zUthuL0L9pFwe/jsWazuS/s//IxLKS/u3Rf/8mI1ul+vLL0v3Xp+4wJMx+nuxaQ0sjmLNu5Ydyll8XlEg5+Fe/bz7Y/6nPzzw738MbNevfrfbuf9P++939+Z5mpiHU9FnlNs8LIBwAClJgpgrmBKBf/82jEFzKCEtMT3ngCGCsC0YPoNJhgE5GhgpscHihRhgn/mhaTuCAxjEMDCMFYDEwMgNDAGAAMAEB0uyYKYTJhLgGGGYHcYQQC5gsgggXTjOoYQIA6ri7hXvzkiHXHpXO5HiGOEZjdxmGGwWNOHAzaGx4gvniuSNfiM9gsW8eu4uJ61hP4tcZi436538WzS3//zX/Fv//mv+fjPjHyw4/ETupmInlTjTbSSgqxkO761nRczCUsBXs2uW5JbYVd8qjwAVuUxmzTTU9fvOCvgwPISUI/S9rtI/3/82jEGC8LNplI0hmkzLsCKZmO3GnSsWrWqeV5dyuVhEOgf7/d8uZ9vtyTSL8bvby5Vo5iVF/gyODgkReGXUFeHaSNQ9EnXkWdy3LcO01NSvq10I1FWabWChYa/XW19tf///D9Jmd3dihYLRhLMKEtOWIeQgrgttjnMmUh8VQjo82QEqynJlY2EPEuKjvz0kl5cJFuvTXo9oysK7dZm1u/Nm8UqGjsfuER3Kzv3xUFTslVtSToSTV2RTpqim50jjiKRsRUAGBdpWPJNRL4+hD0QKgOmPspFlf/82jEJiCa0s5ejguGMA2YtNtvqEIw6U0K5wuoMbJFhALCRYVX/ZgDBttbtZZa/XZW+6ykzspd+t6w1Ty+Tds61oacYqdnVlEgH//ES+27S//M//iQsZGylqKAY6S7fgV3//Ugl1Ay9kTq",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "1",
    //     "sample_rate": 16000,
    //     "seq": 2,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "gAa5SYa5qJy+VOuYAiHeW4YGw99a5rfY+xNpZkwewx+5RLO8zr9aohxLs2sfpf3ewtRkusn1bwq0szS0Ezgth14al9mzdz/H+UxgJnk2OAAICMm8I4QGJVjnet0KsjneyMc5P+uymMvIGFCnn9T/82jEbis8DoSw2I2Q7pfzxKlKyEzanJUQcmss8mmY17RV6xCPb5ngyz7KgzGwnfMwAIPdn7GNHg8mUQQ3D9jLZ8s4ADD07v22Hk9TtIMKpuXWSx1mnmMR7wdh00ODvUZ+mAGO4sv/p6hMTP1H/8kxbfdRPBIRJ90/3sNDECMEc3Ed/F8uxQyLhLp3IHCnOkXT0waEZ3ppk+bMEAOKqSNS2MsQw8FEgawKBMI4fl73kGIy973N9foiJCEINtE5uXEOw4xoNCR5du25EHKi1c0xMhPYInqkzjT/82jEjCyUCt4+WhOXQukTaDouZISElZWRspIyQTgyKgs+pKwRPjVxikiehZjkUKW2hglV1ITKcjkljbEGW8ea5+HNsjsSmW6rY5fuGxCMGyDFNOv59sdZACAG7Rk2iK/MVlNyvUbuCSjS0LX1nec/92msL4etiM7bq/2IUYjGHGMB2GF2mTO9G4gzhxETFhV3SuM2O4VyWJaCeI3fm19269hqXYvjj9i29m3X1p8bjbD8K1Ere0Ca44KZdOnS01ekbFRn7/85EkNdm1DL8zh5y1proIPQG3D/82jEpCwy9t5ewxOqnOzKlcdbfbwl06mvpbUGAjESoyS7na7lboM4rVlCFlmiz5vPK+vBNhoUtvRapnjliSELyr1L7KibtRSm8xhShImJVbP/yZopMic7MzOYsjXI69OecAgAEKQpUtR1tK9WTR6VLXcmqdUWWidHvQqrkFV+lHS3lRbmUKMxWcKyf+m1tDUR3QoY5RK8wR2gRagz96b36Km4oS86p6zDnv9WKhpFErUqTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqr/82jEviXLPs5ewwVOqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqtRiLpuaRK/H/r7eRjMIglWCOkfgRiAcASHZ5WG/UEsBEoP1/5gHonPr/lhsbX/85se3Q2KXOgeIa2W39vaNHmHmxKJqTWXPxWVv9Ef8xgJzSkMBPR1SoDX/0L/QpW/qFARN/Uv/v035RKgqRR/6vc+q2Wg==",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "2",
    //     "sample_rate": 16000,
    //     "seq": 3,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "TEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqpwBAWOSTQpzdsw+nzg9QA6D//zaMSnHLNC2j5ixN7wGmO5P2SOoSVFUEjAQUYc9HDPkyXFuVL5Jrzxo4BpG24m+KueRSO0q5UxAlNsBIPMo4Oih90SHpYoOhjiHJZFHUMFC1oODXLfd9z773v5ZLeubSkqam7ixeEtFmZqTyRc973e90MjWeVl+mv4i0KcVqFpEoXjir0obet3Nc3bzONv/dz/70pK3cP3pIIm0qD8Q0Z7RE8fEIJECRLtJd93j4fyEBUHz0lIMMNDPAQCII/vr2s+idQpPZ3+/HqDMhmMxDiEQg+kDESZq//zaMTcKfvWjl56UQmxYDDocIWyRDLF8U7JChq9C9tNGAv7FS7A/LgaB+Hig0Qo2ddF4hG4hBCFeF+X9+rEQlIyLjun9IjfHTl46jjr8JkmYzncrw388Z468Ca2Mw971u/h1vvW9XYHWoD1Ptj9nj2kh+BAb7v4j/b3MeBLJ2DLqDJH3BgSsigXSUU6ps9jP54ESqHvqQ2VzZIjGryFn4dq7Q5DG1TI4YCpQ/SHzvFAwx0Qww28lbO7WAYOBAxiPhjbh9na5KgiAbnHMbHmcL0nW/S8Kpzu0P/zaMT/OAQWll5BnrzgLopdzV123Hpeb7K6s/EIp3Opr6LF7+Pp5ToxwULkBWPhlWn40ztF13YcrSD2fha59yjKgZUdXrF5DUlRKbCaXHjc3rRa+oO1sSUrHMA6naIeRGHYJkh9AEah8wPiyuHG0WsqdIBDafiOTAZE8TiWFgnh8eIyoxKxDXur9s2vctOVB8XcQZCzM7mYLy4ch/qcOdL2//YM3Dn+Xze2NtZermp5HhWjGFEkTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqnIINJcUaf/zaMTqMfwWmjzDBzz+LB2i8tlu8calGAh8w0SLKow6ppdDBgOuCWA3AcM0AnrafHY2MEnCChH9TmsY4DIAzh54vDE7NDgJ97mcYyuBIYl9izEmvQjOtS4/4igIBrOm1FgsaxzHPchSdisTm1NaQ2fQ1/+n5qGsqmziIQBKZVmqQmIpvT00LPTyRKs+Uzk1KD2c86pAf/bmOqFgec7op0f3yTFKTEFNRaqqUAAElIANl9nVfGnpEGzgnox8RcKzhnBCm5h2SeIjAYaDh2apZ+ZX2ZQdgJXbSf/zaMTRJ0Musx7eVNAudamowCAnLByn3PcaLTTczCBsyQXTWjM5Uzx3BLNX77v/+0z1llegq/rUSlMuMVntI0lDP/SSy5OnHbQkKjHh//f///lf/2SSKV3nxZQLNkk7yrIkRVZiH2NIiEXVnNYmCwDgoJFMQxvsy/jSLbx/tYiJprsfxSImo/cykSLcFA1SmDwsrI27///39+6XepUuhjOrCYotO4Aq26lPOOGwBHswgJDYt0PKh9BAyl+GPuwFwaZOZp1ClmiJFqXYldZuLRDGijjajEI2Wf/zaMT5MSwWif7aS5Q1HYSVQ5lgJkbh2WIQgLNK7byXUjdzBGTPCm33Jp8RU87FbAi/EKDxFiDxL0+Hzc3qCf+9YL1SxnmP4W6qRjh7rXwny2qMaxnOu9j53/895EtT/Xrv4zWEzPmKX334tcHe3RXBqWmE6WE9Gl87jqFdLTkWbM/cK11nsk9tY181jUrmtrRtxd1+86+ca7FGv7MV7RgVNWod/rHChBpYCrIvNFAQ",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "3",
    //     "sample_rate": 16000,
    //     "seq": 4,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "DDlXO3cglTAQhCYLFuefkOYahqCQESwWAVIkiDQdMRyUMrBZMUQwMf/zaMT/NcM+cBbmnrBoMkJqz2xt2SQMPRqMLicMghSEghBQJs+cAAAIXcjRhQJphyDpgmAKqDaWKKHX9CoIDAAoD4fr9zla0WXssjFJvzYlCKZCIJDmzWrTN5v+atfRHa9fbrLnXllKZ2stM/TunLMwb8zP2x+mzOwrXjlcpbP1QjCEaCMem7hYSGhNKwHRoBqFZsKAPABEgDRiWywmUoZMJZgbGi/0REMFMQ6oqA0VCI70PyIr9NEo7fb////9qKVxknP4KABpfM4W5Q96wAVDZggAHJCmTf/zaMTzN/v+aALrBXcOWpKqaHbJgQDBgFJgYfRFBi4plAVkOK/GEIXBcQGPQmbEJAYI13MOhbDVbWHiEQmSlYZeBhgoBFvC7C/Icd5pxeoQMQg5VtWP4OmJDzvJfbeNQZoJWKCu9Y1V6fqWo8pjG/1c6zvf9rbcd/Hr/67+b7//+I/+PrNVeoJvufMNyLmf7coIjqeTpEfZzo986b21QoATkhzaW9Rp5qUyudnWrFA/fiF2gzmSP+oGBuc+0dEL6ccQCADUvR//U2oyHjaSdbWGSypvro5/vP/zaMTeNRsudBTjx1hu+9WekrGlbVq4zmq+Aui/xXG6/5DNPv//5qdwEsBJF6jRXb5On8YVEEczxOgKFb5djrxi+3chOjKw4UQ2BhAyCoOhuPKzNfAQRYRvHcieXK+MwyNx6G1/1yH4eDv+L3u/+VLDgdu9YdDQJCiJ+tkjFGV5IdA2EoCBunyqFEh/fVioNaFlF5f6mkLPFw8q4i6uoM54j3/9YsB4fnyMKONMR4u/vqtK/+P//ilveaO6QQxgiCmblSHoWAUDykxBTUUzLjEwMFVVVVVVVf/zaMTUMUQW1l5+kUpVVVVVVVXSBk1uXbVt7RdR6XgQxdDfIA0ePi/1ucVwsVVE9mu45hOYMZU71v/FS2gtY1da98QDlFxXUNltXMpISWmeABQrVcrk8aSvTq6BvANosp2M/1CyoR3IQq3hNnIMAkJgcvrdWEnb6lESLyqVJf2AYeKmXzB4WX/Q39Skb8RFVFT2CyH/w0e4T31/8aRfaJTsi08qTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqtAB3+i48bUr1XqStv/zaMTFJAq23l55y6IQBUzR5Gmaa7hX477chVBAbO8/ZYPCegHyXvYTgmLSdXF0d0IEAzIhOKqnKwr1D8WKrM304Unxyt6qmC7zrX1rt6L4Ict8FqMNwa6xSC4uRUEwOgo92OIAATrIJh85yLUeAgcZT9jnr50IyPoxxM7seqEDgdEjhRFEw+5xcqj3pJ193EaHZHd5Dp9tadloVk36f/9mkoKV",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "4",
    //     "sample_rate": 16000,
    //     "seq": 5,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "wEaGbPab7/wzwzpEjzJ+wcKp+axt2QuRMKmARVUGf/rinSxaapznJppDk8///eUpd6/jz//zaMTXKJwWoXbLCt73fs7LrH/zIywmatv6atmLv/6vqLu2Jb/43b09NWzWsBOHQoVs6UkdTmchPDEHrPxHJltYS+IAScoj1LiokwznQb5fhcSRIM5S8owb51GSZRovGyRWRnFzcWpmlplkUcRyVqtT51oWr2xWtiHNp+m+qkLaLJ11t/I6mnq3YrbGf9/Preiaw2PzjW34RnnD3nIT+3J5ZZ3gLhzZlB4UMOpMQU1FMy4xMDCqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/zaMT/NJwWoZ7Tx1yqqqqqqqrRSEEu1olWY44bwr0gq0QoRYim/q06ihoGpFWICBUlEcTH+ZOv/8JxaxfP/hsTNv/+dwZt//5nQ176UQ9MGRCZMx2BhOCO4KLE7IX8dhMj5Wbjh44HAwiOtkCxYreYaYwtWwsAoBAZ7RIaHTPdbqX///opUepbq2VVHCwTBVgC/6XTIw0AiC+gWaomz9jJEyZqTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqMQl2bR//zaMTFJBK+sb7Dytqtsm/Mb+HzmZYGPECsBrM1/cEXC27ZwFNWSdtwcqdAMpan2/8olcvaI3EuPDzyUmbSJSqZgDqrXmI2y+LkuN1nggYJyAktHs1b//bFws/WE0aTAeXgxU5yzyM9x1K5DdGU45iMRxgQD4mJmKRTuRquev/9G/Y8fdMhx51O5KX///oQm9ryJu6v29lqaKJfrdDrHMyf5djlgAE1WJM5r5assi2qeWp+mKEpoGGZUAKqvzZtPUYCCCqWeaIGfsAAE04PfRKkhIjMccbFgP/zaMTQJuviwl7CS0tEyGiPswYCADAGECJvaqCgsxgMWg/6E0xgEMxIDCKs2EOMvPwyIMQBC8ymSDIJKzUzdEpyZVBBcFiJzxHgybKKlhdKIQ9QzDDmMxZqD/NdhLtQOsVTZUlSGYtPTNmNxCkufrK/dpK+f/929Gp2Xze9atUL+Q3B9uT43JkZABgYOHdZG9YJfbtCgYykCkThTS/QXkEBPo08uwgLWewNv5+HYZgJo887lJL32htkzLU2UuJywtNpJe4cMLDJihJcUUuRXMIElUBixBCIyv/zaMT/UNwWid7eTXhPxtEeWbsTQ0DCASDFncfpW+08zEW9afSwdDE9aoI+DkiGI5rJp038/Klqbz/Hn5v7KhOD2V00iZTpIXJMQPNJ1ZQs4MqYCgGN4Z+2e23/f5a+aeAWcc/P8ck3TOFQc0bW/ecaUq3CIiJTQEkXDf5hpyzCGTYCTgIBo4+tM4z6lwjeazVNgUAQUp61NbZSumUSy9zZTKHWb6gCKimjqjiLC9FmdVPzGMqvo6GlflZKl7RUERKIl0cwYRG1ADGzMUcJqocq51CMY5XnDP/zaMSGLEr2rn7RU2zIqsrR5tCKSFCs9yxpxKQgigbZ5OQikUxRTcC4BBUi4PAFJJf//+WWYUF0VXCCCFytFyb/8Pu/dYeQrc/ncfydCHhS8kfejxy320sMjQuyDr+vSKQBQNk9Z/1UMnCt8P/eTaQXXpEuogvYbSzbC8//SyIQn0Dr2uWbYi3ubveTXdJ3V2ZJ8gylq6EPZk+zK26Kr2q5DqVVcO5EKwgBZ2VjgwZ0t+XuxWtt/2////9L30kUzDoq",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "5",
    //     "sample_rate": 16000,
    //     "seq": 6,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "tZYCbsv0km9rev1XuQXAK+Hv53DP///zaMSfIgwSsh7CRRYZlHWm/+4a1kkccytWntb5/0LKS5ChElprVqvGX9UxQVKz3pykv17dBkZ/ntaZ/08bjdu8+rB066lmRxj5V1kRbRfkYldrVRoggBx1y8REWd//+n/8KEgeJUUKhyw0TAByPNPYqxBBf++7qUHnVe4s4eExRI0VDVCcaCeYYruRlUGY3PfR7H/3kZfu+x7/6N//v2aeimFCoqMWNjcfD0qF8C6CGPpMQU1FMy4xMDCqqtqag3NbtG5tj/d5VbURSTVkk/1rNzd7/aP3mf/zaMThLrQS1l7CFa5lzD9SUkXVg/9ZfllSJHBprzZ0U5l2U1llFAVLyM0tz4dpSqal4tajdqbnZXb0VATSuImH0nMJXuNswIBEWaLG/c8uFYJQszPpLLEER2f8xQ6nUo4cbXrWkLhPUkhUnUYV9daytDfaofjVOm6k4/A4h4lhiudN3ODQcRtdmu38YFL9MRH/1Gk/o2mjKo1/0MYciXj4UIDaTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/zaMTmLGQW3l7LS7KqqqqqqqqqqqqqsgQCN0JaJNkhvW7lPKG5iIi0iE05fxz5vH44izd/ut83vQQF3b3ZNL70hfsROINkVUrpTLcas64T8FrmTd13LXag+RN/UkAkHJZDnjxUXDVr6qKxQDoj81Df9mb8iP/MMGAh8srsBAT/q3+aX5AaGczaDHQMDOK/LM0ljzskVrJPPb6zJkiVOqEwsKDqTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/zaMTBIyLOwl7BxWqqqqqqqqqqqqqqqqqqqqqqqqqqqriCnjciSs/8M709GHLLZGNo0+XL9TGmlyUg8Bmu4zCjQYAHQbxeq//+ViZo+sVjb6kDSW3tN512qJd7/r4xghJ0xL619wYb5tm+KeqkNF7N6Rd61hlrT2dlUqTecMBMn0DALOlYOZW//9W/mo5fqwEKMNgqAv1MhStjkQPeqx3uPe87TEFNRVWAXLkFx0leSqG6doaegBEJnqBGIc4bDBosDJc9sBRl1zE4EM5ngAgl2msy/4AjcP/zaMS3ILrGqZ7TxN4QNoB8hWl7OgviHsDaiXTDBbIl4ksWQuSiOvGoFKJx/Dk1fP8DLKwax8yx+4x66gRN3gKxiffN7fWLzUp9Y/ft+nmNYp8zQc5kt6VxJbO93vGjagvZ/m+////8fXxTWc339wLxKfWtx/GjZkbLbiesG1/T3/+fr0zf4+cZ+c039/0gQP8V3m+cX+mSmvDHSXfmwRW/77tQ",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "6",
    //     "sample_rate": 16000,
    //     "seq": 7,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "aQMd+NqrMchZAAAEAQNk6zEgmdUoVc9pUWxILfT4Xco8NKGYoCzQgKHUzVmRWfpgS7FiOP/zaMT6MXumbNdceAGiQ3EZIChzTLnZS2f6OuW1p85qVXXXXc20rVK/L4SOBHggZYkoyzldekfVlTPXVwpYlHsnpjOdPfwhiHF3ye2+zgoZJurSjMWkUAWZLTw/kruf+H6e3SLWR6T0afDzdnLeJHGjWU0hh2D0vq1+Nyi8rh3JZjK78OWO13WEkzIqU2hZygIajpgrftjQdARVLkQiaYcQwYB6QF1AIs9jVqxLM9O/L7eFj43f5xnylcJVI1JfSDl9vqWsxduD/wyyhTRuD9N0UPChYsyhtv/zaMT/UtQWil2YwABuskSpbCyi5Obz65DsRSclfXkrSyMUnJZ/w9QxuUQKqNTByayVjW0n2ZNle+BJuQUsvgtnLEWjoIwUBuMHAwKHUMfTsla+uFm8hvTvKt5ddr9dYhSH54Qst9NCQDcDrK+LFnqsnLXVGkh0j1gUQFYhB+IQoKtA1D5FHHpNvdQtsS5FPBBBQLXpGVFyloV3R7alIuiktekKq7j/+Hn5jn//+a72UeyCd69ZNlGt0prr28ZHE0V/jd7mx40fOy83I6d3uqjr25/r/7gf///zaMR+I5vC1l3JQAP8ccNU3TD4KxoHqrrofFjh1UxBTUVVVd/9tttrGnhV6VqJIg+shIxQxa0xwiIyFZD0yxIeTSkcPWXkgelDwRO3tsJuP6wch1op+WZb8vV2rzfLb9ZFerzNVLbcYim9+FcTf/LzCMxoV16gE4BkDj8QnLYryKXhwlH6E650H6d9TUXjL/ll3pHlkO1gQGT2RxEq5ACXaz61TEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zaMS0H+N61lpIR6pVVVVVVVVVVd/9ttrrWhCF10zRtd5QykTMJHhKmQWJIRRYudKKLGCoRELJHmlgpWSUdTacHQCy3JpCVbMw0snsuU1PJx014g+j9q2d9aMZDLVHLN2e6Id/9NaqxjodDUFxQeKDo+7OLbu5gpHQjmOnZVcVKV5ZNHl1Iiv5WZJ1ZKc7urpbS/YaLkcWZHVUY6HR1saQqOLKTGusR/rd9EI9GZpMQwEIDAiHOD4s9nXzYInMsocziLzBA2YCYRE5ikMhxHYQgAXFm7bb9v/zaMTDI5wS0lxJivbcpneAgyNTKAp18k4EDYj/OMpij1XaPf7M7FTlJNv+zu9+1T/399p8skecX8d/nn59b/C/EytrG5ZYzi6rDwkh4RS2iRgNVHA9ASWuOw7VMgvJXfqvcmiv1jKxYdk29aR/RBi8pI9gQzF2Wp9DpAuqdV9+s2WrVvHJ46tcPpkx9a89VmKI6VuUWtXWx9ZrZmqINJWRhxWmTEFNRaqqKZZaGFd7EBdq0qCELAYYIi2ZvYGdcjgYMCeJAMFAZAAAmA4ImRSZmfoVHRyZUf/zaMT+MnO+pvjhmPyBveRBamcGwuLtwc0iHu5VdxRZw9BTy+gmHgTsSBs81k6CXmfPwrw2yyj3/mFxN/7XFaLf/c63/0+N/+F1/pQkTY2PggZa/nOE8vJo2lcgujFZolXtpGIwsqzFDiZEuKYQUUsqylBSDbndgkJUYpdYeVMHyV00FtItj3RuEmbG4m47fC9s2+V5QXsv/aX5hT5oX/C/GF/6",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "7",
    //     "sample_rate": 16000,
    //     "seq": 8,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "TEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqq0cePz2sAAKTNNS1mkpVGGaCQqzRISWjsLMP/zaMT5MULCmxjuUpl3lJEpUEjxTJUoQDcCltfsKlLONq21mNRAYPny93rwBpWoawzm2VKh/mXLiYlDqrm8EsoP7boFxrin2gienuhDBsyTKKsDijT6qMhdF79xwxa75TdX8GN7TiJPBEPI9SqbHm3cnybf+bmvVQxNsVDCgtO1Tzw2DdfElZOLrfMUeuONB3/Da799VPUJtoBXjv6RpHR6KFBeTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/zaMTlLDMmnl7WFphwsVKuRoklO9r0zOKFdgFItzOPw099kLBfImegIHhUzVAk0B//6WiDmto8TBHYiawUivUmd2PAPS2cl0uh7BddFQfgifYU3oYy+vg5OhNIr/LT1ZyblgfVyZSDBxMWMFGZeQ2vnrSOIYaiLQqiYScdRF+Ww7LQ0FzoGHJDRF6QadgOOMiASNKGyxGOs/63UYVIrESTwZqqTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/zaMTLJZHuul7DBy6qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqjCTjs2kksu9skU0KpCZl0TywJB0lOAaGhPSAkaqtChZEgBgFGSO620SJEiU/VyRGmkSJiQNv/l/vytNx9m0SktRkFUXLYRnzslEq7U8t+YyPSjoHgYVGO8PXUqO3v/3/sYxrrKXbUz//NtlVpZRE18xxVg0Bf/6PpuUWTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/zaMSvHsM+zl5Jit6qqqqqqqqqqqqqqqqqqqqqqqqqqqqCUxyRpNuWkg/msrBxGEpj0zqdG57vSmZWiKdS2PiZ49cmK03J0d7uHy6HGZnnrNb70bbLDq5OGudWKxUFGfY0Sqs4z3y7Uu8NyoWVZTQEKJhRLf/RUel/6KVGtWg83mZnldj1k2LZIMuyOpLI781GoZ87OaHVuUqeZZXYRCDwNFA5TEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zaMS2IHtmkb5gjXpVVVVVVVVVFZScf1SSS09o0F8xBoq7AsaIhcM4siMvEzT5JLUEoOihUDzAaiTKory1WNVybZothWpL+ZpKYiYi41ZZRZobTFkwvHrfC699s1dQ231BoqU4qprVNnT3XNzLqqPV7vi5LWjA2EtSVSos8y0XN8pI254/ppT2ZIqahq9apUb1xonhgUTfdv+87tyD89raqmlV",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "8",
    //     "sample_rate": 16000,
    //     "seq": 9,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "TEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zaMTEI9NqebZ6UFNVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVRv3I5LLbbd9/5oS122m4clR32c/kiEt2dyOPnz+q1qn//58/f1b5pxzMSWSOpt3zlb/RIKoKJOR00jnpI5I0KtUp5fsyl+zH1SNmP/i8afJS57Mars3S+rqpq/5x3ZvWlWZfod/8qCTnOnXSq1VEHhvQJirRuQUewsqYZ0psDjoipGBIKMwNkYumzB8aCmeF+XkgyMUkXl1+JR7WEPRCGn+t2J6mpaluKXL9e7uiv/zaMSuHku2fb4wz8vO9fJ6S84uEhxI+VZEIlIYEyg6TkhAdURMzpbUBpEaKFQqLGtSrF4qoiWc7XcpNI6zWrZmRZpAd6sEqfWQm1csVipFqTlECxowzvJ9r7bdMxpA84jVl4zQz3Y3JtRDBIjGbuBiVOV1ndZZjKVd6ru+JmCHAr3ld3MED07zt5fUWNV9I6mlmg0aswYU0S9aUxmDPC+JPDzFzu1IFRUYGCBsoqqlgVc7zO9AUogzsvpZfukq5Vcb+FNjk/ks4S6gyu/NC/e+sWFabx4uq//zaMT/M5wWBALKX1wCaKy7a6zN2qx22A9gxrWozRok+4/1CpTc8sJ1Gf3m7DeJLpii6tGgX3aFakaFG3WHTw8a8aI88lbaw9pBgfFZ9wYsm41tXnvqLGka/Cc4knh6rHU80SI4ws1hX9poEF7D3Ag5rG1BzG8OJeeFI8j4zTN8Odc3swosd4ItpYvC8P0dz6iSxq5gQLQIcmry4tJiDI9wZLDFxKoERmRRmQ2qNxOOSORtmz384DhrG9P0qODm3q0rumFIkPfLVjelLLH41LGt41KZ3LHHIv/zaMT7MgvmAAFYeAH2qOlxxs1/rMsikaWEYJeqVK+FPl27jlLDGhwMHZOZc+aVKaMXlz7P4Z2M9fu3bEA01Lc1oc2VA8WA6iQ/dn7+vu54Xb9jfO3uWtaP/dNeFNe/OG7NePOAUJRJkwJukneWr1uX83ax/tf569L5/mufYwQohwACjIDgcUBReGmWAECYMCXrQMsXLl+zZ5h2i12r21a3un5Y38v+i7rs43Na6Gj8uOhILOBAAyINWO01tlbbyH9/8Fwfr//v//9/+/zWHyWT9/H+4Y9w5//zaMT9QovmUl+Y0AN5/17cs5XypOFkfT/j1ZHUMzZNtre3SKTms1WpCw1xy1UlQ7H/YPYdELHEcCa4sRItYI4IeBO+G6DY2N+YMBWajJ2Hx7r7q3LoREvpXjRg5C1Y/LnIgGPvorBReioXXf5pY6OXo4gEaRDAC/CDNmIULZWX507eu1RK0r/TcL7A0T4sZkjLX3d+vIJyH/mXSh1ts71yP4JJ0cTj7E3npaK+/9bkP6wl/YEnonZpopNxSPq/cd/HEXo8L0w3K4+7UrpJHQSa9HoRDdHLIf/zaMS9SQQOrl+YwAPZVBMo3Wh6HKam6/8w4D+TmcS+OQ9TxSM2KfGUQfdltqNzkTh/+Z4yuX491En8vQfDLnvxDF39WLWHf721u3nq9b/+/+G+x+L4Tc/STdr6fWdvDPuee+3t371PJc7fLlultWL1epcVlDAne726iHHJ5LWr7xwtOkpsRA1rLVrGUF7Q4XO8ZDVVsgJB4VDDNXgVBwKRG2Wh3W2nE0aLENjCgJacKg0ySlTJoiNAk8wQJhQIiQLXe7at4AAyJ7krHXZhh9R01h283nn+Uv/zaMRkNHL6wx/b4ACJZhlhzedi/EJZhh9r8t3IGlVrL/y1jYyw/+fjrPG9r8sstYWtZZZa/Xf5jjj//3H8dVs9ZX7+sN/zPeOH/3m+ff7//+HcrF7HPVy5X7v8uX9XJydnK8oleF7HLLK4BxYKHDaSpKsFf/Lexg43sQ==",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "9",
    //     "sample_rate": 16000,
    //     "seq": 10,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "2CigCkbcbdzkzRIPg/JvilRd1vJdEBEAfAOQmKk/+h6zKjf/5iM5rBRyjf2X2RUECCOLzYSu/6lYyAXYg81mkv0u+LmTRdXHLKtlnMiwNh0X+MFV/7ijmWL+UkVO//NoxF0qGzbaXn4RDraRgjOAsNaaoeIYfBBdX/on/kGNrzW56HXMY0G5R811UjxwsLX1cI5sN19xf8XKcMypaLcqojjBgeB3BwUE6zjYuvo5Bva1grMkQCq45rABJ2pO35fq5ne+CEFQQsHHgD6hrgGAM4OAF+nyd+jAdCWz/5U+jx+st9fCcOQQsIyjcRrIMKAo7R4xgGAz/yznVGOKo5zvYSD39Df/9Sl+kpdUVH1nRZkSJiIkNEbcaZxEq20/e1+tEKKtSiGVjPsNZA8LK5wi/+v4dtcV//NoxH8fwzLaXsPKekxBTUUzLjEwMKqqqqqqqqqqqqqqqqqqrESgBy6J29Z3Tep2wFAogjBblLiCBXADxLldqNc9FAdZ0zb/T6eNFQq2L4CcewhQEej+AiYHAwQagKkEprVIkJxmtvKTWYMxIZyIMVEhlJS///Un9ekz3NOxWlJEnK4WPMhn1/17Ib01o/ZXM1SIhT1IcS1qf//+33/y29XaIepMQU1FMy4xMDCqqqqqqqpoAYmxku+/3X9kpKUAMdr3FxUeqxhkZjz76PJ3kGlgMHVkzqGp//NoxLQf1BbOPnjFMhumgM0AVZNFawnqAVEFyl7SWQdvQQkWxZ+Y1IaaMMhU3cB16CMSwOBcBcG9li48bkVUjUZBRJsOyxIKVHJ7p8u5FX9aVN+NODgUkuwnCV176k1HlLkYxXc1Y5RybyIRRXJDB3BlRMVEu7wiQ6OMERHt+ogUGvBguWyEGDEHCYDhwYBBRytP////6vV856uhzR4oNByuJi2EMlVybXV8dC6/vGMAPLahJKrvs7jy//68dUen+6F+VVN59pH2/A8BVKWPWD/jb2Ll7r4///NoxPAu/Bad/tILeHz7VbWjfocXAn6HCxgHZpEsEjAMx9gJgvjQJaY4jgtD4yEP4wB4McFPmGrjrJ378bz+hBECnljA4Gnev1SMrn269/+fd+OXf3XfyWW+BjDhgWWzrX5SKd0ybkybX0EMZ1r5SsashSOhRgjRtztUno6JygYYIATFZOkFGSdJMEBQCCEAZMCBjqYFwNvhCCZIuMDgXJ/6Rt7ShAKBQeX1PlogwAFIHrY6PRdBVIsRuzWI8tWzT3f97Rz31t81nIvtTMrfLXezjOVmNL59//NoxP80JBbCPHmTzoVUrgr4/P/4+pLOpEEgVIokLKBQnJGrlKrr/P///W7U095U8QIUpGY3c6l5z2thmS//n73H9n40+M0Sr0nzEOOTjpjBSPPAgoWabl2FVWG2mUcGZI5GG6MsHKQihxPDrMk8C1P0nSeQsnJHilmwninJeX0fD86S7q9eLiwASwwA3Qw0uMEiALhfgkEy7LqNMFIHUDJOkk4/4jcdaCH+U56C2MCRHqU=",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "10",
    //     "sample_rate": 16000,
    //     "seq": 11,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "jAZU+IEIPwRNJTMUFADhyraUoVWzgtrJeWa42uP6S/8vJThii//zaMT5NOQWqZ5iX1wdsrux8T7hWWprONte1X2jqvIpkrkXP4QUHFlGCgoJoEG+UNWnv6fivvn5qBDcYeyFiGCcFCKMmh2NFVxu0UlM2l/HtLLONsODRDOIDshyyGwpyh02hnzsVfmnutY6qyLeabs1fURKMnzi5yZsHtjwDyUrlcshzFJyFMSXAHJuWD6WnhSf+eE6tE61EpO2mqxytd7WeVcmR+pMQU1FMy4xMDCqqqqqdmt2lqUhIAJ+HmdKVvoShJgLKeCMmjEZkimaUqmEkRMBmYtZm//zaMTwL1wWpjhiGXSMGKBoVChYDSGUXISwuYWDxEcDRQ4AVKOlUlkNg8DLIKsOawgEaA/Ejk1Z9F2SG/Y3lSPxTxCU0FypLX/izsNYhydsVn8jtK8682vUU3S1aWml2OdBnn3ZHSGZmrnKav/syzKGuDAA8hyKjEJdbkb6N+j9kIDJFpCKYwgTKFyA+6a/r9V9b19FdH/rmFA1OgXCoaPO0OZVTEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVWtDKoEmSogE9T/MuUXFM2CN1MA25br+M//zaMTwLsuesvzeRLzZXGxo5SDxgOFo0VXrCFC4P/+jAAaWp0y7cRqBcEyR9pRDXv6PAlIyejwpsVOfo8cvctk9HlLIlDTKXhlNWrZ1Wt4lEpbNzzygysrzCR0//F3nd8b5//2/zFsY2uYups6RRi4nvdxT5yKNemIqkOoehcGsXWZYr5yCtczjN94xzLIwZAKKCoiAykZv6nAotIagF4FDroFcTEFNRTMuMTAwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqoA4DADvb2WFd0DCujirUv/zaMTjK7sirv7Rh4yNh7b1pUFxQVCiROmuX70PCAChvF8ME0gINARB456ct3IJXA0ypqZZSqVrDvz9T5kUll9VCrxEBoZpELxGh0VIQL1o/YQYr3vh9+3hSrpn/VfZs2H2vjP9/xvklY2mLg4mViBqZ0HJloXfp3fv3NeXVskrfYKNiJtdIAd1xM1n3gVaxwnBIJtDgKiGdkf13D6TxlmcF1lawwDJrNDy3eCoAKyBpYqIVlrZqllTJy90hrV+1J6TILPLJ4bm1gjCQHKZ7aTPERwNPMn0K//zaMTaKWKmnW7STUQaVmrU/0KFDGFy8FWappEdBEUkKxWwS1boiFIzbaJtfG1b+/x+Xf/84f+vnqtu3ViyliE5qbUUDMkVSv793/+vLb37kHt4vT0iYXJyaRtdtx5AiVXIGVO9HTHqUZ+M15e024QY2TDHIxIXDcmJqMKG7I3oCSGLgEDCbaWEYBxcAZoUGF2hQhJyAUHSdtcjFaPFyMn1N5BG",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "11",
    //     "sample_rate": 16000,
    //     "seq": 12,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "TOg2o3JIW0DOOT0Hy3wAwjHAjXpiU9y6/I1ms0eZ1lyP6wtOXjzYOihv17xBGIxVMyEZnv/zaMT/MrQWlWDeElTpEP06lOKOw9yQ4RmH2XOu6fus7KlxgdOcUFGIIEICjwHEGjbjlNv+9VXTfGmlY7EcPxIeaIDRJyKwsCuZchCl3LEEw5Nxp3INusJZo0yLLDtYa801GtzojL2TNeaisHxzWpPytTNQ5SDoGZJ5kWoJISdU5kUIABCwAERGErKaiyUE6dSeECQtHZNNdtFIEASj5IIyhUQqqCwkCJzjOJm1jXTfMWVOEGMSPQRAaaaECZIwwsAhMYxeBlagCLoPvQJbmuJxOjQ4b9twd//zaMT+MlQWtl5hcVxBoUN78NwiG6aZCtCcXnbv0Trzs7O419IX1/txxMcnJ5+S1wkExcaADrh7EvC2WTstpTtezb3L+/DWbxTvffpnvnJr1H/anKTCeFcjyvJhYcXtvn8bPOwz+/vZO2+85k7TvaYlZVleT+gqvEQWsg2CIRXlZfXLKffZv/TXLPH0f1maR3s9eyEEwVIZjjxVMoy6JJ6dPSmOT1IIROjZMT0uqUMER1d7DoxW9UxWwnBXgtVMQU1FMy4xMDBVVYMERXXZIW0S7SY0mWrscf/zaMT/OQvmniDWGJFYE6moQPd1JAoQ5BaUyaJUcmpSAwWOCmuBG48w8AnLdAwqOBzgBlMSLmAwIfMMaLchT8uYk41TiTrqOo34+0KM5hVBgG4Qg90QmWdCVCZ7kKS7AogHUHm1ZCqiocpnVFuqojaKub3RSXaPKImCyMHA+JFEiGImVJK6uvpvY5SoMOLHwVIiQShp4s/VQssGSV7CT//ySMSrhADwFgBmp6OtnHI6VSwDbttVhci9owCNqYOfQVrr4CEqhC8VPEWnTAETuWkS3tNjJDBgzP/zaMTaKYKWwv7Dyyh4wBDnnd2OaEI1JZS5/56ApYOgUjkAzhPC9r7N6JE1S2reEeonxeWUvzY6XDzlvHnedFIqPvQk8Ypp7F5LdRjXyv7z7/virXZlLRnSpWRTRAPjoOI2kCYYA4XEsZkK5CGc2R4VkRsucNCpXzchRWgk6lg+IuCuBpq8Rz1V+NWOeLURmOehdgwcSIs9skepqrI769f8Vv7WnlOfjaRmUKjmlUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zaMT/NRP2lhbSUZFVVVVVVVVVVVVVVVVVVVVVqBm5AFRAuV/KeXfXiEoTOzzs8kjcAUpTViDodqUCpt3LszQR5g1+n/+6LNE2eRNaVtiEEIdsEAWhJY4gmv5jaX+77r/42OLQyFQtgMOZL2cT/1o050vv9KIkqmPZTtquiJmuxnILpfzK7pdGDxkF5VJdp106aE4hcIFi5cU3uRtXbnJc2Qk1rlsjSIMrKd0k+4XRQA/H6EtLEJCZMp/NLLSsB+3qzVmamnz3wn/jTXn92asGBuC8ZoXYIP/zaMS7IaLWwj7BhRa3OoEF+4/KsYpFfMoFeo37XsbhcCQHimXSbIJCMw02ZKqUAzPBahLlcPA6zhRp9l4YFSax0V8SM4f6rHeNqvwyRDv03Ylcl63KZRtFzZUjFm7ZRJoU26JtR2K2GyCDbRVRcVioygcI9bXGEbiNupqi4YQMMe/7q/kLrP/hZjFKbMo2yduVICMPAhPvFe+k0kxsgukkCAgi4nsuh0PrTA1h+TMP0S7tUG5WjOkqxRZcWg==",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "12",
    //     "sample_rate": 16000,
    //     "seq": 13,
    //     "status": 1,
    //     "type": "0"
    // },
    // {
    //     "audio": "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",
    //     "bit_depth": 16,
    //     "ced": "48",
    //     "channels": 1,
    //     "encoding": "lame",
    //     "frame_size": 0,
    //     "id": "13",
    //     "sample_rate": 16000,
    //     "seq": 14,
    //     "status": 2,
    //     "type": "0"
    // }
],
				audioIsPlay:false,//语音是否正在播报中
			}
		},
		computed:{
			user(){
				return this.$store.state.userInfo
			},
			writerText() {
				let str = this.sparkResult.ai_format.slice(0, this.currentTextIndex);
				return str;
			}
		},
		watch: {
			user:{
				handler(val,oldVal){
					if(val){//登录状态-获取当天历史提问记录
						(val.avatar) && (this.userInfo.avatarUrl=val.avatar)
						const topicId = this.$route.query.topicId;
						if(topicId){ //获取当前topicId下的所有问答记录
							this.topicId = topicId;
							this.getQuestionList()
						}else{ //获取当天历史提问记录
							this.getLastTopic();
						}
					}else{//未登录-获取游客提问次数
						// this.getQuestionCount();
					}
				},
				immediate:true,
				deep:true
			},
		},
		created(){
		},
		mounted() {
			window['keywordClick'] = (keywordList) => {
				this.keywordClick(keywordList)
			}
		},
		beforeDestroy(){
			this.stopTypewriterEffect();
		},
		methods:{
			/**
				* @description: 超拟人合成
				* @param {*} text 
				* @return {*}
			*/			
			superhumanStart(text){
				let audioList = [];
				this.superhuman.start(text,(data) => {
					const { header,payload } = data;
					if(payload && payload.audio){
						audioList.push(payload.audio);
					}
					if(header.status==2){ //音频文件全部接收完成
						console.log("音频接受完成！")
						this.audioList = audioList.sort((a, b) => a.seq - b.seq); //根据seq字段排序
						this.playNextAudio();//语音播放
					}
				}, data => {
					console.log("err data",data)
				})
			},
			/**
				* @description: 递归播放音频文件列表
				* @param {*} audioCurrentIndex // 初始化索引，用于追踪当前播放的音频文件
				* @return {*}
			*/
			playNextAudio(audioCurrentIndex=0) {
				console.log("strat",this.audioList)
				if(!this.audioList.length) return;
				this.audioIsPlay = true;
				// 获取当前要播放的音频文件
				const bytes = this.audioList.map(item => atob(item.audio)).join("");
				const audio = new Audio();
				const ab = new ArrayBuffer(bytes.length);
				let ia = new Uint8Array(ab);
				for (let i = 0; i < bytes.length; i++) {
					ia[i] = bytes.charCodeAt(i);
				}
				const blob = new Blob([ab], { type: 'audio/mp3' }); // 或者相应的MIME类型
				console.log("blob",blob)
				let audioURL = URL.createObjectURL(blob);
				audio.src = audioURL;
				audio.play();
				// 播放后释放audioURL资源
				audio.onended = () => {
					console.log("end!")
					URL.revokeObjectURL(audioURL);
					this.audioIsPlay = false;
				};
				return;
				// 解码 Base64 编码的音频数据为二进制数据
				const binaryData = atob(audioDataItem);
				// 创建一个 Uint8Array 来存储二进制数据
				let uint8Array = new Uint8Array(binaryData.length);
				console.log("uint8Array--",uint8Array)
				for (var j = 0; j < binaryData.length; j++) {
					uint8Array[j] = binaryData.charCodeAt(j); // 将二进制字符串转换为字节值
				}
				// 将 Uint8Array 转换为 PCM 数据
				const pcmData = uint8Array;
				console.log("pcmdata:",pcmData);
				// 创建一个 ArrayBuffer，并将 PCM 数据复制到其中
				const arrayBuffer = pcmData.buffer.slice(0);
				console.log("arrayBuffer--",arrayBuffer)
				// 使用 Web Audio API 播放音频数据
				const audioContext = new (AudioContext || window.AudioContext || window.webkitAudioContext)();
				console.log("audioContext---",audioContext)
				audioContext.decodeAudioData(arrayBuffer, (buffer) => {
					console.log(11111)
					let source = audioContext.createBufferSource();
					source.buffer = buffer;
					source.connect(audioContext.destination);
					// 当播放结束时，触发onEnded函数
					source.onended = () => {
						console.log("end!")
						// 增加索引，以便播放下一个音频文件
						audioCurrentIndex++;
						// 检查是否还有音频文件需要播放，如果有，则递归调用playNextAudio函数
						if (audioCurrentIndex < this.audioList.length) {
							console.log("在此调用")
							this.playNextAudio(audioCurrentIndex);
						}else{
							this.audioIsPlay = false;
						}
					};
					source.start(0);
				}, function(err) {
						console.error('解码音频数据时出错:', err);
				});
			},

 
			async playNextAudio1(audioCurrentIndex = 0) {
				if (!this.audioList.length) return;
				this.audioIsPlay = true;

				// 获取当前要播放的音频文件
				const audioDataItem = this.audioList[audioCurrentIndex].audio;
				const binaryData = atob(audioDataItem);
				const binaryLen = binaryData.length;
				const bytes = new Uint8Array(binaryLen);
				for (let i = 0; i < binaryLen; i++) {
						bytes[i] = binaryData.charCodeAt(i);
				}

				const audioContext = new (window.AudioContext || window.webkitAudioContext)();

				try {
						await audioContext.audioWorklet.addModule('audio-worklet-processor.js');

						const audioBuffer = await audioContext.decodeAudioData(bytes.buffer);
						const source = audioContext.createBufferSource();
						source.buffer = audioBuffer;

						const workletNode = new AudioWorkletNode(audioContext, 'my-audio-processor');

						source.connect(workletNode).connect(audioContext.destination);

						source.onended = () => {
								audioCurrentIndex++;
								if (audioCurrentIndex < this.audioList.length) {
										this.playNextAudio(audioCurrentIndex);
								} else {
										this.audioIsPlay = false;
								}
						};

						source.start(0);
				} catch (error) {
						console.error('加载 AudioWorklet 时出错:', error);
				}
		},
			/**
				* @description: 音频播放大模型返回的ai内容
				* @return {*}
			*/			
			aiContentPlay(content){
				if(this.audioIsPlay){//正在播放
					this.audioList = [];
					this.audioIsPlay = false;
				}else{
					this.superhumanStart(content);
				}
			},
			/**
				* @description: 打字机效果
				* @return {*}
			*/			
			startTypewriterEffect() {
				if (this.typeInterval) {
					this.stopTypewriterEffect();
				}
				this.sparkResult.isWrite = true;
				this.typeInterval = setInterval(() => {
					if (this.currentTextIndex <= this.sparkResult.ai_format.length) {
						this.currentTextIndex++;
					} else {
						this.stopTypewriterEffect();
					}
					this.autoScrollToBottom();
				}, 100); // 每0.2秒更新一次
			},
			/**
				* @description: 停止打字机效果 清楚定时器
				* @return {*}
			*/			
			stopTypewriterEffect() {
				clearInterval(this.typeInterval);
				this.typeInterval = null;
				this.sparkResult.isWrite = false;
				this.$forceUpdate();
			},
  		/**
			 * @description: 点赞/取消点赞
			 * @param {*} item
			 * @return {*}
			*/
			async handleLike(item,index){
				const isLike = item.isLike==1 ? 0 : 1;
				const result = await this.$http.spark.likeOrStopLike({id:item.id,answerId:item.answerId,isLike});
				this.sparkResultList[index].isLike = isLike;
				if(result==1){
					this.infoFeedback.type = 1;
					this.infoFeedback.id = item.id;
					this.infoFeedback.answerId = item.answerId;
					this.infoFeedbackShow = true;
					this.sparkResultList[index].isStep = 0;
				}
			},	
			/**
			 * @description: 踩/取消踩
			 * @param {*} item
			 * @return {*}
			*/
			async handleStep(item,index){
				const isStep = item.isStep==1 ? 0 : 1;
				const result = await this.$http.spark.stepOrStopStep({id:item.id,answerId:item.answerId,isStep});
				this.sparkResultList[index].isStep = isStep;
				if(result==1){
					this.infoFeedback.type = 2;
					this.infoFeedback.id = item.id;
					this.infoFeedback.answerId = item.answerId;
					this.infoFeedbackShow = true;
					this.sparkResultList[index].isLike = 0;

				}
			},	
			feedbackClose(){
				this.infoFeedbackShow = false;
			},
		/**
		 * @description: 获取问答记录
		 * @return {*}
		 */	
		async getQuestionList(){
			const content = await this.$http.spark.getQuestionList({topic:this.topicId})
			this.sparkResultList = content.map(item => ({
				me:item.question,
				ai:this.keywordMatch(item.answer,item.wstQuestionAnswerKeywordsRefs),
				status:2,
				id:item.id,
				isLike:item.isLike,
				isStep:item.isStep,
				answerId:item.answerId
			}));
			this.autoScrollToBottom();
		},		
		/**
			* @description: 跳转历史记录
			* @return {*}
			*/			
			historyTopic(){
				this.$router.push({path:'/history-spark'})
			},
			/**
				* @description: 获取当天最后一条话题
				* @return {*}
			*/
			async getLastTopic(){
				const {topicId,wstQuestionAnswerList} = await this.$http.spark.getLastTopic();
				if(topicId){
					this.topicId = topicId;
					this.sparkResultList = wstQuestionAnswerList.map(item => ({
							// me:this.keywordMatch(item.question,item.wstQuestionAnswerKeywordsRefs,'keywordName'),
							me:item.question,
							ai: this.keywordMatch(item.answer,item.wstQuestionAnswerKeywordsRefs),
							status:2,
							id:item.id,
							isLike:item.isLike,
							isStep:item.isStep,
							answerId:item.answerId
					}))
				}
				this.autoScrollToBottom();
			},	
			
			/**
			* @description: 接收录音数据-调取识别接口
			* @param {*} data
			* @return {*}
			*/			
			async soundEnd(data){
				// if(!this.user && this.questionCount>=5){
				// 	this.$toast("请先登录");
				// 	this.$router.push("/login");
				// 	return;
				// }
				this.isLoading = true;
				this.autoScrollToBottom();
				// this.superhumanStart("小田正在琢磨您的问题，让我想想哈");
				const res = await this.$http.spark.audioRtasr({type:"pcm",data});
				this.isLoading = false;
				if(res.errorCode){
					this.$toast(res.statusMsg);
					return false;
				}
				//设置定时器检测语音播报完毕后在调用大模型发送问题
				const timer = setInterval(() => {
					if(!this.audioIsPlay){
						clearInterval(timer);
						this.handleSpark(res,1);
					}
				},300)
				
			},
			/**
				* @description: 获取当前用户提问问题次数
				* @return {*}
			*/		
			// async getQuestionCount(){
			// 	this.questionCount = (await this.$http.spark.getQuestionCount()) || 0;
			// },	
			/**
				* @description: 输入问题方式切换
				* @param {*} way
				* @return {*}
				*/			
			methodChange(way){
				this.inputType = way
			},
			/**
				* @description: 创建话题
				* @return {*}
			*/	
			async createTopic(title,type) {
				this.topicId = await this.$http.spark.insertTopic({
					title,  //标题
				})
				this.addQuestion(this.sparkResult,type);
			},	
			/**
				* @description: 添加问题回答记录
				* @return {*}
			*/	
			async addQuestion(item,type) {
				// const item = this.sparkResultList[this.sparkIndex];
				const {id,answerId,esKeyWordsList} = await this.$http.spark.addQuestion({
					id: item.id,
					topic: this.topicId,  //话题id
					question: item.me,  //问题
					answer: item.ai,  //答案
					llm: 1,  //大语言模型，1、讯飞星火、2、百度千帆
					questionModality:type, //问答形式 1：语音，2：文字
				})
				this.sparkResultList[this.sparkResult.index].id = id;
				this.sparkResultList[this.sparkResult.index].answerId = answerId;
				const matchStr = this.keywordMatch(item.ai,esKeyWordsList);
				this.sparkResultList[this.sparkResult.index].ai = matchStr;
			},			
			/**
				* @description: 复制文本
				* @param {*} text
				* @return {*}
			*/	
			copyText(text) {
				const input = document.createElement('input');
				input.value = text;
				document.body.appendChild(input);
				input.select();
				document.execCommand('copy');
				document.body.removeChild(input);
				this.$toast("复制成功");
			},	
		/**
			* @description: 
			* @param {*} text 问题对应的文字
			* @param {*} type 问答形式 1:语音 2:文字
			* @return {*}
			*/			
			handleSpark(text=this.text,type){
				if(!text.trim()){
					this.$toast("请输入您的问题");
					return false;
				}
				this.sparkStart(text,type);
				this.text = "";
			},
			/**
				* @description: 调用火星大模型
				* @param {*} meText 我的问题
				* @param {*} isAgain 是否是重复提问操作
				* @return {*}
				*/			
			async sparkStart(meText,type,id) {
				//游客不可提问
				if(!this.user){
					// this.$toast("您的5次免费体验机会已用完，请登录后继续使用该服务！");
					this.$toast("请登录后使用该服务")
					setTimeout(() => {
						this.$router.push("/login");
					},1000)
					return;
				}

				if(this.sparkResult.status==3 || this.sparkResult.status==1){//上一个问题正在回答中
					this.$toast("等小田为您解答完上个问题再问好吗");
					return;
				}
				//提问方式为语音时 调用超拟人合成播报问题
				// type==1 && this.superhumanStart(`⼩⽥正在思考如何回答${meText}这个问题`);
				const obj = {
					me:meText,
					ai: "⼩⽥正在思考，如何回答您的问题，请稍等",
					status: 3,
					type,
					isLike:0,
					isStep:0
				}
				
				id && (obj.id = id);
				this.sparkResultList.push(obj);
				this.autoScrollToBottom();
				const idx = this.sparkResultList.length-1;
				this.sparkResult = { ...obj, index:idx };
				let totalAiText = "",totalAiTextStr = "";
				this.currentTextIndex = 0;
				if (['init', 'endPlay', 'errorTTS'].indexOf(this.bigModel.status) > -1) {
        	this.bigModel.start(meText,(data) => {
						let {status, text} = data.payload.choices;
						const contentStr = text[0].content;
						const content = this.strReplace(text[0].content);
						totalAiText = status==0 ? content : (this.sparkResultList[idx].ai + content);
						totalAiTextStr = status==0 ? contentStr : (this.sparkResult.ai + contentStr);
						this.sparkResultList[idx].ai = totalAiText;
						this.sparkResultList[idx].status = status;
						this.sparkResult.ai = totalAiTextStr;
						this.sparkResult.ai_format = totalAiText;
						this.sparkResult.status = status;
						if(!this.typeInterval){
							if(type==1){//提问方式为语音时 设置定时器检测问题内容播报完毕后在调用打字机效果展示内容
								const timer = setInterval(() => {
									if(!this.audioIsPlay){
										clearInterval(timer);
										this.startTypewriterEffect();
									}
								},300)
							}else{
								this.startTypewriterEffect();
							}
						}
						
						
						if(status == 2){
							if(!this.topicId) { 
								this.createTopic(meText,type);//创建话题
							}else {
								this.addQuestion(this.sparkResult,type);
							}							
							// this.questionCount += 1;
						}
						this.autoScrollToBottom();
					},(data) => {
						console.log("error",data)		
						this.stopTypewriterEffect();
						this.sparkResultList[idx].ai = this.strReplace(data.header.message);
						this.sparkResult.ai = data.header.message;
						this.sparkResultList[idx].status = 2;
						this.sparkResult.status = 2;			
						this.bigModel.close();
						this.autoScrollToBottom();
					})
    		}
			},
		/**
		 * @description: 替换字符串中的\n \r换行符为<br/>
		 * @return {*}
		 */	
		strReplace(content){
			return content.replace(/[\n|\r]/g,"<br/>");
		},
		/**
		 * @description: 关键词匹配
		 * @return {*}
		*/			
		keywordMatch(str,keywordList) {
			if(!keywordList || !keywordList.length) return this.strReplace(str);
			let keywords = keywordList.map(item => (item.keywordName || item.name));
			let replacements = keywordList.map((item,index) => {
				if(item.children && item.children.length){
					return "<a href='javascript:;' style='color:#7FBE26' class='keyword' onClick='keywordClick("+JSON.stringify(item.children)+")'>"+(item.keywordName || item.name)+"</a>"
				}else{
					return `<a href="${item.h5_url || item.h5Url}" target="_blank" style="color:#7FBE26" class="keyword">${item.keywordName || item.name}</a>`
				}
			});
			let pattern = new RegExp(keywords.join('|'), 'g');
			let newText = str.replace(pattern, match => {
				return replacements[keywords.indexOf(match)];
			});
			return this.strReplace(newText);
		},
		keywordClick(list){
			this.keywordPop = {
				show:true,
				list
			}
		},
		/**
		 * @description: 页面随内容自动滚动
		 * @return {*}
		 */
		autoScrollToBottom() {
			this.$nextTick(() => {
				document.getElementById("resultWrap").scrollIntoView({block:"end",inline: "nearest"});
			})
		},

		/**
		 * @description: 手动停止回答
		 * @return {*}
		 */
		stopSpark() {
			this.bigModel.close();
			this.sparkResultList[this.sparkResult.index].status = 5;
			this.sparkResult.status = 5;
			this.stopTypewriterEffect();
		},
		/**
		 * @description: 重新回答
		 * @return {*}
		 */
		againSpark(item,index) {
			// this.sparkIndex = index;
			// this.sparkResult.index = index;
			// this.sparkResult.id = item.id;
			this.sparkResult = {...item,index}
			// const text = this.sparkResultList[this.sparkResult.index].me; //获取重新回答的问题
			this.sparkStart(item.me,item.type,item.id);//重新获取答案
		},
		/**
		 * @description: 清除会话/创建新会话（flag==true时）
		 * @return {*}
		 */
		clearSession(flag=false) {
			this.sparkResult = {}
			this.sparkResultList = [];
			flag && (this.topicId = "");
			// this.bigModel.clearHistory();
		},
	}
	}
</script>

<style lang="scss" scoped>
	.content {
		background: linear-gradient(188deg, rgba(127,190,38,0.2) 0%, rgba(127,190,38,0) 10%,#ffffff 15%,#ffffff 100%);
		height: 100%;
		// background: #ffffff;
		.result-wrap {
			width: calc(100% - 20px);
			height: calc(100% - 203px);
			overflow-y: auto;
			padding: 10px;
			// .wrap-main{
			// 	width: 100%;
			// 	height: 100%;
			// }
			.question,.result{
				display: flex;
				align-items: flex-start;
				margin-bottom: 12px;
				.info-box{
					max-width: 265px;
					padding: 10px 12px;
					box-sizing: border-box;
					border-radius: 4px;
					font-size: 15px;
					color: #242424;
					line-height: 26px;
					text-align: justify;
					b{
						font-size: 16px;
					}
					&.question-info{
						background: #7FBE26;
						border-radius: 16px 2px 16px 16px;
						color: #ffffff;
					}
					&.result-info{
						background: #f6f6f6;
						border-radius: 2px 16px 16px 16px;
						.btn-group {
							border-top: 1px solid #DEDEDE;
							display: flex;
							justify-content: flex-end;
							padding-top: 10px;
							margin-top: 5px;
							.btn{
								display: flex;
								align-items: center;
								margin: 0 12px;
								img{
									width: auto;
									height: 22px;
								}
								.van-icon{
									font-size: 24px;
									color: #71B019;
								}
								// span {
								// 	margin-left: 3px;
								// 	color: #7FBE26;
								// }
							}
						}
					}
					&.default-info{
						width: 265px;
					}

				}
				
			}
			.question {
				justify-content: flex-end;
				.avatarUrl {
					margin: 0 0 0 8px;
				}
			}
			.avatarUrl {
				flex-shrink: 0;
				width: 32px !important;
				height: 32px !important;
				margin-right: 8px;
				box-sizing: border-box;
				border-radius: 4px;
				overflow: hidden;
			}
		}
		.foot-box{
			position: fixed;
			bottom: 18px;
			left: 0;
			right: 0;
			.btn-stop{
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				line-height: 20px;
				color: #FF580E;
				margin: 10px 0;
				.icon{
					width: 14px;
					height: 14px;
					margin-right: 3px;
				}
			}
			.tool-bar{
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 10px;
				.btn{
					display: inline-flex;
					align-items: center;
					justify-content: center;
					padding: 0 13px;
					height: 36px;
					border-radius: 18px;
					border: 1px solid #EBEBEB;
					background: #ffffff;
					font-size: 14px;
					color: #242424;
					margin: 0 5px;
					.icon{
						width: auto;
						height: 14px;
						margin-right: 3px;
					}
					&.btn-green{
						border-color: #71B019;
						color: #71B019;
					}
				}
			}
			.editor-wrap {
				width: 345px;
				height: 48px;
				background: #ffffff;
				border-radius: 11px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-shadow: 0px 1px 18px rgba(0,0,0,0.12);
				margin: 0 auto 15px;
				// position: absolute;
				// left: 50%;
				// bottom: 15px;
				// transform: translateX(-50%);
				.van-field{
					flex-grow: 1;
					background-color: transparent;
					font-size: 16px !important;
					border: none;
					textarea{
						font-size: 16px;
					}
				}
				.icon{
					flex-shrink: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 0 10px;
					&.btn-send {
						width: 32px;
						height: 32px;
						background: #7FBE26;
						opacity: 1;
						border-radius: 50%;
						img{
							width: 18px;
							height: 15px;
						}
					}
					&.btn-sound{
						width: 32px;
						height: 32px;
						img{
							width: 18px;
							height: 22px;

						}
					}
				}
			}
		}
		.shengming{
			font-size: 11px;
			color: #999999;
			position: fixed;
			left: 15px;
			bottom: 8px;
		}
	}
	.dialog-keyword{
		.list{
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			justify-content: center;
			min-height: 100px;
			.btn{
				padding: 3px 6px;
				border: 1px solid #7FBE26;
				color: #7FBE26;
				font-size: 16px;
				margin: 5px;
			}
		}
	}




</style>